import { render, staticRenderFns } from "./AssistantPanel.vue?vue&type=template&id=17804bcb&scoped=true"
import script from "./AssistantPanel.vue?vue&type=script&lang=js"
export * from "./AssistantPanel.vue?vue&type=script&lang=js"
import style0 from "./AssistantPanel.vue?vue&type=style&index=0&id=17804bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17804bcb",
  null
  
)

export default component.exports